import { render } from "./GameForm.vue?vue&type=template&id=123de12a"
import script from "./GameForm.vue?vue&type=script&lang=js"
export * from "./GameForm.vue?vue&type=script&lang=js"

import "./GameForm.vue?vue&type=style&index=0&id=123de12a&lang=css"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__